import {Filter, type FilterProps, type FilterProvider} from '@github-ui/filter'
import type {NestedFilterProvider} from '@github-ui/filter/providers'

import {getCustomPropertiesProvider, type PropertyDefinition} from './providers/custom-properties'
import {getAllDateProviders} from './providers/date'
import {LanguageStaticFilterProvider} from './providers/languages'
import {getAllNumberProviders} from './providers/number'
import {getAllStaticProviders} from './providers/static'

export type {PropertyDefinition}

type Provider = FilterProvider | NestedFilterProvider

interface Props extends Omit<FilterProps, 'providers' | 'sx'> {
  definitions: PropertyDefinition[]
  /**
   * Optional filter providers to override the default repository filter providers.
   * If not provided, all repository filter providers will be used.
   */
  providers?: Provider[]
}

export function ReposFilter({definitions, providers, ...props}: Props) {
  const actualProviders: Provider[] = providers || getDefaultReposProviders(definitions)

  return <Filter {...props} providers={actualProviders} />
}

export function getDefaultReposProviders(definitions: PropertyDefinition[]): Provider[] {
  return [
    ...getAllStaticProviders(),
    ...getAllNumberProviders(),
    ...getAllDateProviders(),
    getCustomPropertiesProvider(definitions),
    new LanguageStaticFilterProvider(),
  ]
}

try{ ReposFilter.displayName ||= 'ReposFilter' } catch {}